import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Names the step between the client and a training plan after the tab the plan lives on: Adam Nowak > Plans > Plan. */
export const Route = createFileRoute("/(private)/trainees/$clientId/training-plans")({
  loader: () => ({ crumb: m.client_tab_plans() }),
  component: Outlet,
});
